/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { fetchTags } from '../services/killshot';

const PricingContext = React.createContext();

export function PricingProvider(props) {
  const eventMeta = useSelector(state => state.pricing.eventMeta);
  const [tags, setTags] = useState([]);
  const [skyboxId, setSkyboxId] = useState('');
  const history = useHistory();

  useEffect(() => {
    if (eventMeta?.skybox_id) {
      const sbId = eventMeta.skybox_id;
      setSkyboxId(sbId);
    }
    fetchTags().then(data => {
      setTags(data.response);
    });
  }, [eventMeta]);

  useEffect(() => {}, [history.location.pathname]);

  const value = useMemo(
    () => ({
      skyboxId,
      tags,
    }),
    [skyboxId]
  );

  return <PricingContext.Provider value={value} {...props} />;
}

export function usePricing() {
  const context = React.useContext(PricingContext);

  if (!context) {
    throw new Error('usePricing must belong to PricingContext');
  }

  return context;
}
